import { Image, Table } from '@themesberg/react-bootstrap';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { returnUserReadableDateTime } from '../../../utils/datetime';
import StatusCard from '../interBranchTransfers/StatusCard';
import { useParams } from 'react-router-dom';
import { updateSpinnerState } from '../../../actions/spinner';
import { updateToastInfo } from '../../../actions/settings';
import { apiCall } from '../../../middlewares/api';
import { apiCallConsts } from '../../../constants/apiCallConsts';
import { getDatesField, getPriceField, getPricingStatusColors } from './utils';
import NewTable from '../../../components/common/NewTable';

const RequestsDetailsPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [request, setRequest] = useState({});
  const schedule =
    Object.keys(request || {}).length > 0
      ? request?.[getDatesField(request?.choose)]
      : {};
  const priceTitle =
    Object.keys(request || {}).length > 0 ? getPriceField(request) : '';
  const title = priceTitle
    ?.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  // console.log(schedule);

  const fetchData = async () => {
    try {
      dispatch(updateSpinnerState(true));
      const data = await apiCall(
        apiCallConsts.GET_METHOD,
        `internal/pricing/${id}`,
        {}
      );
      setRequest(data);
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t('failed!'),
          message: error.message,
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <React.Fragment key={id}>
      <h5 className="my-4">{t('Price Change Request Details')}</h5>
      <div className="d-flex gap-3 p-4 bg-white">
        <div style={{ width: '30%' }}>
          <div
            style={{
              border: '1px solid rgba(46, 54, 80, 1)',
              padding: '10px',
              width: 'fit-content',
              maxWidth: '22.5rem',
              height: '16.5rem',
            }}
          >
            <Image
              src={request?.images || ''}
              alt="image"
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
        <div style={{ width: '70%' }}>
          <div>
            <div className="fw-bold mb-2 fs-5">
              {request?.productTitle || ''}
            </div>
            <div
              className="d-flex gap-5"
              style={{
                // maxHeight: '7rem',
                marginBottom: '20px',
              }}
            >
              <div className="d-flex flex-column w-50">
                <div className="d-inline-flex mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    VAN No:
                  </div>
                  <div>{request?.vanNo || ''}</div>
                </div>

                <div className="d-inline-flex mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    Current Price:
                  </div>
                  <div>{parseFloat(request?.vsp).toFixed(2) || ''}</div>
                </div>

                <div className="d-inline-flex  mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    {`${title || 'vs_price'}:`}
                  </div>
                  <div>{request?.[getPriceField(request)]}</div>
                </div>

                <div className="d-inline-flex  mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    Request Date:
                  </div>
                  <div>
                    {returnUserReadableDateTime(request?.dateSubmitted?.iso) ||
                      ''}
                  </div>
                </div>
                <div className="d-inline-flex  mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    Status:
                  </div>
                  <div>
                    {
                      <StatusCard
                        status={t(request?.status?.toUpperCase())}
                        bgColor={
                          getPricingStatusColors(request?.status).bgColor
                        }
                        color={getPricingStatusColors(request?.status).color}
                        minWidth={'14rem'}
                        height={'2.5rem'}
                      />
                    }
                  </div>
                </div>
              </div>

              {/* Right Section */}
              <div className="d-flex flex-column w-50">
                <div className="d-inline-flex  mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    Requested By:
                  </div>
                  <div>{request?.requestedBy || ''}</div>
                </div>
                <div className="d-inline-flex  mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    New VSP:
                  </div>
                  <div>{request?.vs_price || ''}</div>
                </div>

                <div className="d-inline-flex  mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    Reason Of Change:
                  </div>
                  <div>{request?.requestedReason || ''}</div>
                </div>
                {/* <div className="d-inline-flex  mb-2">
                  <div className="fw-bold" style={{ width: '45%' }}>
                    Schedule:
                  </div>
                  <div>{schedule?.desc}</div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="fw-bold mb-2 fs-6">{schedule?.desc}</div>
        </div>
      </div>
      <div className="bg-white fw-medium mt-2 fs-5 py-3 ps-2">
        {t('Price Change Request History')}
      </div>
      <div className="mt-2">
        {/* <Table className="bg-white">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Action</th>
              <th>Performed By</th>
              <th>Notes/Comments</th>
            </tr>
          </thead>
          <tbody>
            {request?.actionLog?.map((log, index) => (
              <tr key={index}>
                <td>{returnUserReadableDateTime(log?.time?.iso || '')}</td>
                <td>{log?.action || ''}</td>
                <td>{log?.userName || ''}</td>
                <td>{log?.remarks || ''}</td>
              </tr>
            ))}
          </tbody>
        </Table> */}
        <NewTable
          id={'objectId'}
          data={request?.actionLog || []}
          columns={[
            {
              dataField: 'time',
              text: 'Timestamp',
              formatter: (cell, row) => {
                return returnUserReadableDateTime(cell?.iso || '');
              },
            },
            {
              dataField: 'action',
              text: 'Action',
            },
            {
              dataField: 'userName',
              text: 'Performed By',
            },
            {
              dataField: 'remarks',
              text: 'Notes/Comments',
              formatter: (cell, row) => {
                return (
                  <div style={{ whiteSpace: 'pre-wrap' }}>{cell || ''}</div>
                );
              },
            },
          ]}
          isNewEmptyTable={true}
          isFooterRequired={false}
        />
      </div>
    </React.Fragment>
  );
};

export default RequestsDetailsPage;
